import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-placeholder-product',
  templateUrl: './placeholder-product.component.html',
  styles: ['']
})
export class PlacehoderProductComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
